export function AnimatedArrow() {
  return (
    <svg className="-mr-1 ml-1.5 stroke-[1.5px]" fill="none" stroke="currentColor" width="12" height="12" viewBox="0 0 10 10" aria-hidden="true">
      <path className="opacity-0 transition group-hover/toggle:opacity-100" d="M0 5h7" />
      <path className="transition group-hover/toggle:translate-x-0.75" d="M1 1l4 4-4 4" />
    </svg>
  );
}
